var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"col-12 text-center pt-2 mb-2"},[_c('button',{staticClass:"btn btn-link btn-exit",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeSesion()}}},[_vm._v(" Cerrar sesión ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }